<div class="flex justify-between items-center mb-4">
  <h2 class="text-2xl font-semibold">Área</h2>
  <button
    (click)="openModal('add')"
    [disabled]="loadingAreas"
    class="bg-primary text-white px-4 py-2 rounded transform transition-transform duration-200 cursor-pointer hover:scale-105"
  >
    Crear nueva área
  </button>
</div>
<app-loading *ngIf="loadingAreas" text="Cargando áreas"></app-loading>
<div class="bg-white rounded border border-gray-200" *ngIf="!loadingAreas">
  <app-table-generic
    [columns]="columns"
    [data]="areas"
    [actions]="actions"
    [showPagination]="false"
    (edit)="openModal('edit', $event)"
  >
  </app-table-generic>
</div>
<app-modal-form
  *ngIf="mostrarModalAgregar"
  [title]="'Crear área'"
  [form]="formAgregar"
  [fields]="fieldsAgregar"
  [loading]="loadingAgregar"
  (formSubmit)="crearArea()"
  (cancel)="mostrarModalAgregar = false"
  submitText="Crear"
>
</app-modal-form>
<app-modal-form
  *ngIf="mostrarModalEditar"
  [title]="'Editar área'"
  [form]="formEditar"
  [fields]="fieldsEditar"
  [loading]="loadingEditar"
  submitText="Actualizar"
  (formSubmit)="actualizarArea()"
  (cancel)="mostrarModalEditar = false"
>
</app-modal-form>
